import { Box, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'

import * as classes from '@/styles/ContentModuleFormScreen.css'

interface LiveModuleBannerProps {
  message?: string
}

export function LiveModuleBanner({ message = 'This module is published.' }: LiveModuleBannerProps) {
  return (
    <Box className={classes.liveBanner}>
      <IconAlertTriangle size={20} stroke={1.5} className={classes.liveBannerIcon} />
      <Text className={classes.liveBannerText}>{message}</Text>
    </Box>
  )
}
